module.exports = __webpack_public_path__ + "static/media/ncr-angola.d38c1547.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/ncr-angola.jpg
// module id = 1323
// module chunks = 0